// Copyright 2021-2022 zcloak authors & contributors
// SPDX-License-Identifier: Apache-2.0

import { alpha, Box, Container as MuiContainer, Stack, styled } from '@mui/material';
import { useContext } from 'react';
import { Link, useMatch } from 'react-router-dom';

import ButtonEnable from '../components/ButtonEnable';
import DidName from '../components/DidName';
import IdentityIcon from '../components/IdentityIcon';
import { ZkidWalletContext } from '../ZkidWallet';
import LogoZcloak from './logo_zcloak.svg';
import LogoZcloakBlack from './logo_zcloak_black.svg';
import LogoZcloakfont from './logo_zcloakfont.svg';
import LogoZcloakfontBlack from './logo_zcloakfont_black.svg';

const Wrapper = styled(Box)({
  zIndex: 1,
  position: 'absolute',
  width: '100%',
  borderBottom: `1px solid ${alpha('#707070', 0.33)}`
});

const Container = styled(MuiContainer)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: 90
});

function Header() {
  const { didUrl } = useContext(ZkidWalletContext);
  const match = useMatch({
    path: '/'
  });

  return (
    <Wrapper>
      <Container>
        <Stack component={Link} direction="row" spacing={1} to="/">
          <img src={match ? LogoZcloak : LogoZcloakBlack} />
          <img src={match ? LogoZcloakfont : LogoZcloakfontBlack} />
        </Stack>
        <ButtonEnable
          endIcon={didUrl ? <IdentityIcon diameter={20} value={didUrl} /> : null}
          sx={{ background: '#fff', ':hover': { background: '#fff' } }}
          variant="contained"
        >
          <DidName value={didUrl} />
        </ButtonEnable>
      </Container>
    </Wrapper>
  );
}

export default Header;
